import React, { useRef } from "react";

const LectureCategorySelector = ({
  onClickActive,
  className = "",
  size = "medium",
}) => {
  const legendItems = [
    { label: "MINEDU Censos", color: "bg-green-400 hover:bg-green-300", content: "cardsCensoNacional" },
    { label: "Comunicación", color: "bg-red-600 hover:bg-red-700", content: "cardsLiteratura" },
    { label: "Ciencia y Tecnología", color: "bg-orange-600 hover:bg-orange-700", content: "cardsTechSciences" },
    { label: "Ciencias Sociales", color: "bg-yellow-600 hover:bg-yellow-700", content: "cardsSocialSciences" },
    { label: "Arte y Cultura", color: "bg-blue-600 hover:bg-blue-700", content: "cardsArtAndCulture" },
    { label: "Desarrollo Personal, Ciudadanía y Cívica", color: "bg-green-600 hover:bg-green-700", content: "cardsPersonalDevelop" },
    { label: "Idiomas", color: "bg-green-600 hover:bg-green-700", content: "cardsIdioms" },
    { label: "Matemática", color: "bg-red-600 hover:bg-red-700", content: "cardsMath" },
    { label: "Educación Física", color: "bg-orange-600 hover:bg-orange-700", content: "cardsSport" },
    { label: "Educación para el trabajo", color: "bg-yellow-600 hover:bg-yellow-700", content: "cardsManualidades" },
    { label: "Educación Religiosa", color: "bg-blue-600 hover:bg-blue-700", content: "cardsReligion" },
    { label: "Artículos Interesantes", color: "bg-green-600 hover:bg-green-700", content: "pdfGrid" },
    { label: "Tutoría", color: "bg-blue-600 hover:bg-blue-700", content: "cardsTutoria" },
    { label: "Datos Curiosos", color: "bg-red-600 hover:bg-red-700", content: "cardsDatosCuriosos" },
    
    // Puedes agregar más opciones...
  ];

  const sizeClasses = {
    small: "py-1 px-2 text-sm",
    medium: "py-2 px-3 text-base",
    large: "py-3 px-4 text-lg",
  };

  const containerRef = useRef(null);

  const scrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: -100, behavior: "smooth" });
    }
  };

  const scrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: 100, behavior: "smooth" });
    }
  };

  const showNavigation = legendItems.length > 5;

  return (
    <div className="relative flex items-center">
      {showNavigation && (
        <button
          onClick={scrollLeft}
          className="absolute left-0 z-10 bg-orange-300 hover:bg-orange-400 text-orange rounded-full px-2 py-2 focus:outline-none shadow-lg transition-colors duration-300"
          style={{ transform: "translateX(-50%)" }}
        >
          <span className="text-2xl font-bold">&lt;</span>
        </button>
      )}

      <div
        ref={containerRef}
        className={`lecture-carousel w-full flex overflow-x-auto ${sizeClasses[size]} text-white rounded-lg transition-colors duration-300 ${className}`}
      >
        {legendItems.map((item, index) => (
          <div
            key={index}
            onClick={() => onClickActive(item.content)}
            className={`text-center ${item.color} flex-shrink-0 flex items-center justify-center mx-1 rounded h-10`}
            // El ancho se adapta al contenido, pero no superará los 250px
            style={{ width: "auto", maxWidth: "250px" }}
          >
            <span className="block overflow-hidden whitespace-nowrap text-ellipsis px-2">
              {item.label}
            </span>
          </div>
        ))}
      </div>

      {showNavigation && (
        <button
          onClick={scrollRight}
          className="absolute right-0 z-10  bg-orange-300 hover:bg-orange-400 text-orange rounded-full px-2 py-2 focus:outline-none shadow-lg transition-colors duration-300"
          style={{ transform: "translateX(50%)" }}
        >
          <span className="text-2xl font-bold">&gt;</span>
        </button>
      )}
    </div>
  );
};

export default LectureCategorySelector;
